$(document).on('turbolinks:load', function () {
  $(function () {
    $('#exclude-isp-codes-select').selectpicker();
    $('#exclude-product-codes-select').selectpicker();
    $('#include-product-codes-select').selectpicker();
    $('#product-code-installations-select').selectpicker();
  });
});
